import { omniAtom } from "src/utils/atoms";
import { OpenMenu } from "./types";

export const menuAtom = omniAtom({
  key: "menu",
  value: null as null | OpenMenu,
});
